<template>
<div class="chapter">
<div class="inner_page">
<div class="keep">
<h3 class="h3">Dedications</h3>
<p class="noindenta">From Becky</p>
</div>
<p class="noindenta">I believe that you really can learn something new every day. To do that you must let yourself be open to new ideas.</p>
<p class="noindent">When presented with a new way to do something, it is easy to let your first thought be, “No, I do it <em>this</em> way.” I have been guilty of that myself. However, in the last few years I have made a concerted effort to be more open to new ideas. As a consequence, I have learned some new things (not all of them appliqué related).</p>
<p class="noindent">I dedicate this book to the spirit of open-mindedness and sharing that is such an important part of every quilter’s life.</p>
<p class="noindent"><strong>From Linda</strong></p>
<p class="noindenta">My niece Magen is a marine biologist. She has a love for new adventures, like swimming with the whales, dolphins, and sharks (small, well-fed sharks). Magen loves the outdoors, hiking, rock climbing, being with the crew on a tall ship, and more. For the last few years Magen has worked on Catalina Island, teaching children about marine life.</p>
<p class="noindent">I asked her once where this love of the outdoors came from. She looked at me and said, “Aunt Linda, you have been taking me hiking since I was five.”</p>
<p class="noindent">I dedicate this book to everyone who loves a new adventure. Not all adventures have to be outside. I hope you will have many wonderful hours with the adventure of needle-turn appliqué in this book.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781607054726_03_ded.vue?2ab74efb